import { useAuth0 } from "@auth0/auth0-react";
import styles from "./TimeTracking.module.css";
import { useEffect, useState } from "react";
import axios from "axios";

const Filter = ({ setFilterData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [propertyList, setPropertyList] = useState([]);
    const [roleList, setRoleList] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            await axios.get(process.env.REACT_APP_USER_API_URL + "v1/get-all-properties", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                let propertyListTemp = response.data.data;
                propertyListTemp = [{ value: 0, label: "All properties" }].concat(propertyListTemp);
                setPropertyList(propertyListTemp);
            }).catch((error) => {
                setPropertyList([]);
            });
        }
        fetchData();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        const fetchRoles = () => {
            return axios.post('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/oauth/token', { "client_id": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_ID, "client_secret": process.env.REACT_APP_AUTH0_AUDIENCE_CLIENT_SECRET, "audience": 'https://' + process.env.REACT_APP_AUTH0_DOMAIN + "/api/v2/", "grant_type": "client_credentials" }, {
                'access-control-allow-origin': '*',
            }).then(response => {
                let managementToken = response?.data?.access_token;

                axios.get('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/roles', {
                    headers: {
                        Authorization: `Bearer ${managementToken}`,
                    }
                }).then(response2 => {
                    let roleListTemp = response2?.data?.filter(i => i?.name !== "Super Admin");
                    setRoleList(roleListTemp);
                }).catch(() => { });
            }).catch(() => { });
        }

        fetchRoles();
    }, []);

    return <div className={`${styles.filters}`}>
        <select className={`${styles.fsel}`} onChange={(e) => setFilterData(prev => { return { ...prev, property: e.target.value }; })}>
            {propertyList?.map(item => {
                return (<option key={item?.value} value={item?.value}>{item?.label}</option>);
            })}
        </select>
        <select className={`${styles.fsel}`} onChange={(e) => setFilterData(prev => { return { ...prev, role: e.target.value }; })}>
            <option value={'all'}>All roles</option>
            {roleList?.map(item => {
                return <option value={item?.id}>{item?.name}</option>
            })}
        </select>
    </div >
}

export default Filter;